import { SettingsData } from './hooks/use-settings-data.hook';

export const enum SettingsRowKey {
  name = 'name',
  dob = 'dob',
  sex = 'sex',
  address = 'address',
  phone = 'phone',
  accountEmail = 'accountEmail',
  password = 'password',
  clientFacingEmail = 'clientFacingEmail'
}

export type SettingsSectionBaseProps = {
  userId: string;
  data: SettingsData;
  isLoading: boolean;
};
